import dayjs from "dayjs";
import { AnswerData, QuestionaireVersion, QuestionData, QuetionarieDetail, SectionData } from "../../../../../../service/questionarie/response";
import { ExecutionCardProps } from "../../components/executionCard/types";
import { QualificationCardProps } from "../../components/qualificationCard/types";
import { HeaderState } from "../../types";
import { TFunction } from "react-i18next";
import { deleteDecimalsWithZero } from "../../../../../../utils/methods/removeDecimals";
import { Constants } from "../../../../../../utils/constants";

const formatResponse = ({ response, t }: { response: QuetionarieDetail, t: TFunction<"translation", undefined> }) => {
  const dataActionPlan = response?.dataActionPlan
  const dataReportFolio = response?.dataReportFolio
  const statusQuestionnaires = response?.statusQuestionnaires
  // GET PROGRAMMED PERCENTAGE
  const { finalized, notFinalized, scheduled,} = statusQuestionnaires
  const programmedFinishedPercentage = scheduled ? (finalized / scheduled) * 100 : 0
  const programmedNoFinishedPercentage = scheduled ? (notFinalized / scheduled) * 100 : 0
  // GET REPORT FOLIO PERCENTAGE
  const { amountReportFolioApproved, amountReportFolioGenerated, amountReportFolioRejected, } = dataReportFolio
  const reportFolioAprovedPercentage = amountReportFolioGenerated ? (amountReportFolioApproved / amountReportFolioGenerated) * 100 : 0
  const reportFolioRejectedPercentage = amountReportFolioGenerated ? (amountReportFolioRejected / amountReportFolioGenerated) * 100 : 0

  // GET ACTIONPLAN PERCENTAGE
  const { amountActionPlanApproved, amountActionPlanGenerated, amountActionPlanRejected, } = dataActionPlan
  const actionPlanAprovedPercentage = amountActionPlanGenerated ? (amountActionPlanApproved / amountActionPlanGenerated) * 100 : 0
  const actionPlanRejectedPercentage = amountActionPlanGenerated ? (amountActionPlanRejected / amountActionPlanGenerated) * 100 : 0

  const header: HeaderState = {
    averagePoints: Number(response?.questionnaireData?.totalPoints ?? 0),
    dataHeader: {
      "quest_name": response?.questionnaireData?.name ?? "",
      "description": response?.questionnaireData?.description ?? "",
      "instruction": "",
      "areas": {
        label: response?.questionnaireData?.area?.name ?? "",
        value: response?.questionnaireData?.id,
        id: ''
      },
      "departments": {
        label: response?.questionnaireData?.department?.name ?? "",
        value: response?.questionnaireData?.id,
        id: ''
      },
      totalSection: 0,
      "totalPoints": response?.questionnaireData?.totalPoints ?? '',
      "option": Boolean(response?.questionnaireData?.actionPlanByItem) ? '1' : '0',
      statusId: '',
    },
    isSectionConfig: Boolean(response.questionnaireData?.scoreBySection)
  }

  const config: Array<(ExecutionCardProps | QualificationCardProps)> = [
    { qualification: Number(deleteDecimalsWithZero((response?.averageRating ?? 0).toFixed(2))), total: Number(deleteDecimalsWithZero(Number(response?.questionnaireData.totalPoints ?? 0).toFixed(2))) },
    {
      options: [
        { text: t('Questionarie.cards.sectionss'), number: response?.questionnaireData.sectionCount, },
        { text: t('Questionarie.cards.questions'), number: response?.questionnaireData.sumQuestions },
        { text: t('Questionarie.cards.totalPoints'), number: Number(response?.questionnaireData.totalPoints) }
      ]
    },
    {
      percentage: true,
      options: [
        { text: t('Questionarie.cards.scheduled'), number: scheduled },
        { text: t('Questionarie.cards.completed'), number: finalized, percentage: deleteDecimalsWithZero(programmedFinishedPercentage) },
        { text: t('Questionarie.cards.notCompleted'), number: notFinalized, percentage: deleteDecimalsWithZero(programmedNoFinishedPercentage) }
      ]
    },
    {
      title: t('Questionarie.actionPlan'),
      percentage: true,
      options: [
        { text: t('Questionarie.cards.generated'), number: amountActionPlanGenerated },
        { text: t('Questionarie.cards.approved'), number: amountActionPlanApproved, percentage: deleteDecimalsWithZero(actionPlanAprovedPercentage) },
        { text: t('Questionarie.cards.rejected'), number: amountActionPlanRejected, percentage: deleteDecimalsWithZero(actionPlanRejectedPercentage) }
      ]
    },
    {
      title: t('Questionarie.reportFolio'),
      percentage: true,
      options: [
        { text: t('Questionarie.cards.generated'), number: amountReportFolioGenerated },
        { text: t('Questionarie.cards.approved'), number: amountReportFolioApproved, percentage: deleteDecimalsWithZero(reportFolioAprovedPercentage) },
        { text: t('Questionarie.cards.rejected'), number: amountReportFolioRejected, percentage: deleteDecimalsWithZero(reportFolioRejectedPercentage) }
      ]
    }
  ]

  const section: Array<SectionData> = response?.sections.map((section) => {
    /* let sumCorrectOptionSelected = 0;
    let totalPointsCorrectOption = 0; */
    let totalSelected = 0;
    let totalCorrectSelected = 0;
    const [num1, num2] = section?.fractionalScore?.split("/").map(Number) ?? [0,1];
    const questions: QuestionData[] = section.questions.map((question) => {
      let counter: number = 0;
      question.answers.forEach((answer) => {
        counter += answer.amountSelected;
        if (answer.description) {
          totalSelected += answer.amountSelected;
          if (answer.correctOption) {
            totalCorrectSelected += answer.amountSelected;
            /* sumCorrectOptionSelected += answer.amountSelected
            totalPointsCorrectOption += Number(answer.score) */
          }
        }
      });
      const answers: AnswerData[] = question.answers.map((answer) => {
        return {
          description: answer?.description,
          score: answer?.score,
          amountSelected: answer?.amountSelected,
          amountRecurrence: answer?.amountRecurrence,
          percentage: answer?.percentage /* Number(deleteDecimalsWithZero(((answer?.amountSelected / (counter === 0 ? 1 : counter)) * 100).toFixed(2))) */,
          correctOption: !!answer?.correctOption,
          iconUrl: answer?.iconUrl,
          answersOpen: answer?.answersOpen || [],
          recurrences: answer?.recurrences
            ?.filter(recurrence => recurrence !== null)
            ?.map(recurrence => dayjs(recurrence).format(Constants.dayjsFormat4)) || [],
          answersDropDown: answer.answersDropDown
        };
      });
      return {
        title: question.title,
        totalSelected: counter,
        answers: answers,
      };
    });
    return {
      title: section.title,
      totalPoints: section.totalPoints,
      sumCorrectOption: num1/* totalCorrectSelected */,
      totalScoreCorrect: num2/* totalSelected */,
      percentage: Number(deleteDecimalsWithZero(((num1 / (num2 === 0 ? 1 : num2)) * 100).toFixed(2))) /* Number(deleteDecimalsWithZero(((totalCorrectSelected / (totalSelected === 0 ? 1 : totalSelected)) * 100).toFixed(2))) */,
      questions: questions,
    };
  });

  const headerConfig: { created: string, date?: dayjs.Dayjs } = {
    created: `${response?.questionnaireData?.userCreator?.firstName} ${response?.questionnaireData?.userCreator?.lastName}`,
    date: response?.questionnaireData?.initDate ? dayjs(response?.questionnaireData?.initDate) : undefined
  }

  return {
    header,
    config,
    section,
    headerConfig
  }
}

const formatVersionResponse = ({ response, t, id, version }: { response: QuestionaireVersion[], t: TFunction<"translation", undefined>, id?: string, version?: number }) => {

  const versionsQuestionaire: Array<QuestionaireVersion> = [
    ...response?.map((version) => ({
      questionnaireMainId: version?.questionnaireMainId,
      name: version?.name,
      version: version?.version,
      parentId: version?.parentId,
      lastVersionId: version?.lastVersionId
    })),

  ];

  if (response && response.length > 0) {
    versionsQuestionaire.push({
      questionnaireMainId: Number(id),
      name: response?.[0]?.name ?? '',
      version: version ? version : (response?.[response.length - 1]?.version + 1),
      parentId: response?.[0]?.parentId ? response[0].parentId : response?.[0]?.questionnaireMainId,
      lastVersionId: Number(id)
    });
  }
  return {
    versionsQuestionaire
  }
}


export { formatResponse, formatVersionResponse }